import React from 'react';

// @ts-expect-error - TS7016 - Could not find a declaration file for module '@grnhse/seedling/lib/azalea/components/card'. 'node_modules/@grnhse/seedling/lib/azalea/components/card.js' implicitly has an 'any' type.
import { Card, CardHeader } from '@grnhse/seedling/lib/azalea/components/card';
import { GdprCardBody, ContentHeader, ContentDescription } from './components';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('gdpr.candidate_packets.view');

type Props = {
  candidatePacketsPath: string;
};

class CandidatePackets extends React.Component<Props> {
  render() {
    return (
      <div>
        <Card useLegacyPadding>
          <CardHeader label={t('header')} labelSize="large" />
          <GdprCardBody verticalCardGutter="medium">
            <ContentHeader>{t('content.header')}</ContentHeader>
            <ContentDescription>{t('content.description')}</ContentDescription>
            <div>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={this.props.candidatePacketsPath}
              >
                {t('content.configure')}
              </a>
            </div>
          </GdprCardBody>
        </Card>
      </div>
    );
  }
}

export default CandidatePackets;
